import React from 'react'
import Image12 from '../Image/Govt.png'

function HappyClient() {
	return (
		<>
			<section className="clients-section-app pad-tb">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-8">
							<div className="common-heading text-w">
								<span>Our happy customers</span>
								<h2 className="mb30" style={{ color: "black" }}>Some of our Clients</h2>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-12">
							<div className="client-logoset">
								<ul className="row text-center clearfix apppg">
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay=".2s">
										<div className="brand-logo hoshd"><img src="images/client/election.jpg" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "rgb(255, 102, 0)", fontWeight: "bold" }}>ECI</p>
									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay=".4s">
										<div className="brand-logo hoshd"><img src="images/client/BRLPS-Recruitment.jpg" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "rgb(0, 123, 255)", fontweight: "bold" }}>BRLPS-Recruitment</p>
									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay=".6s">
										<div className="brand-logo hoshd"><img src={Image12}
											className="img-fluid" /></div>
										<p style={{ color: "green", fontWeight: "bold" }}>Govt. of India</p>
									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay=".8s">
										<div className="brand-logo hoshd"><img src="images/client/signature.png" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "red", fontWeight: "bold" }}>Signature Grand Club</p>
									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="1s">
										<div className="brand-logo hoshd"><img src="images/client/fcc.jpg" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "black", fontWeight: "bold" }}>Future Choice Club</p>
										{/* <p>Future Choice Club</p> */}
									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="1.2s">
										<div className="brand-logo hoshd"><img src="images/client/gy.jpg" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "rgb(214, 51, 132", fontWeight: "bold" }}>Gyros</p>

									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="1.4s">
										<div className="brand-logo hoshd"><img src="images/client/Nfl.png" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "rgb(25, 135, 84", fontWeight: "bold" }}>NFL</p>

									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="1.6s">
										<div className="brand-logo hoshd"><img src="images/client/t.jpg" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "#11265b", fontWeight: "bold" }}>TYRES SHOPPE</p>

									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="1.8s">
										<div className="brand-logo hoshd"><img src="images/client/sanfran.png" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "#c2a61b", fontWeight: "bold" }}>Sanfran</p>

									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="2s">
										<div className="brand-logo hoshd"><img src="images/client/bsbe.png" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "#b215b1", fontWeight: "bold" }}>BSES Rajdhani Power Ltd</p>

									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="2.2s">
										<div className="brand-logo hoshd"><img src="images/client/bihar-foundation.png" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "#2fe797", fontWeight: "bold" }}>Bihar-Foundation</p>

									</li>
									<li className="col-lg-2 col-md-3 col-sm-4 col-6 mt30 wow fadeIn" data-wow-delay="2.4s">
										<div className="brand-logo hoshd"><img src="images/client/images.png" alt="clients"
											className="img-fluid" /></div>
										<p style={{ color: "#b215b1", fontWeight: "bold" }}>Amar Ujala</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default HappyClient